import styled from 'styled-components';

export const CellInput = styled.input<{ $invalid?: boolean }>`
    width: 10rem;
    height: 3.2rem;
    padding: 0 0.8rem;
    text-align: right;
    font-size: ${props => props.theme.text.size.small};
    color: ${props => props.theme.colors.text.primary};
    background: ${props => props.theme.colors.light};
    border: 0.1rem solid
        ${props => (props.$invalid ? props.theme.colors.error : props.theme.colors.input.border)};
    border-radius: 0.3rem;

    &:focus {
        outline: none;
        border-color: ${props =>
            props.$invalid ? props.theme.colors.error : props.theme.colors.primary};
    }

    &:disabled {
        opacity: 0.5;
    }
`;

/** A chevron for selects, replacing the native arrow that sits too tight against the edge. */
const chevron = (color: string) =>
    `url("data:image/svg+xml,${encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path d='M1 1l4 4 4-4' fill='none' stroke='${color}' stroke-width='1.5' stroke-linecap='round'/></svg>`
    )}")`;

export const CellSelect = styled.select`
    height: 3.2rem;
    padding: 0 3rem 0 0.8rem;
    font-size: ${props => props.theme.text.size.small};
    color: ${props => props.theme.colors.text.primary};
    appearance: none;
    background-color: ${props => props.theme.colors.light};
    background-image: ${props => chevron(props.theme.colors.text.secondary)};
    background-repeat: no-repeat;
    background-position: right 1rem center;
    border: 0.1rem solid ${props => props.theme.colors.input.border};
    border-radius: 0.3rem;

    &:focus {
        outline: none;
        border-color: ${props => props.theme.colors.primary};
    }
`;
